var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgX({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "11px",
    height: "11px",
    viewBox: "0 0 11 11",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "0CBD9EF6-2577-44F0-BE73-26B53E8AEFF3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Compliance-Sub-Category-Add-Notes",
    transform: "translate(-1295.000000, -306.000000)",
    fill: "#787878",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "x",
    points: "1297.00308 316.463851 1300.57012 312.061633 1304.13716 316.463851 1305.77012 316.463851 1301.33448 311.167733 1305.58482 306.063851 1303.94027 306.063851 1300.55854 310.283444 1297.1768 306.063851 1295.54384 306.063851 1299.79417 311.167733 1295.37012 316.463851"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/x.8a667a0d7c49010fe16af444f1b8018c.svg";
export { ForwardRef as ReactComponent };